module.exports = __webpack_public_path__ + "static/fonts/Sui-Number-Bold.d8c09cc.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Sui-Number-Bold.otf
// module id = 614
// module chunks = 36